/* paex-size-guide.js — Size guide - PE: Phase 1 chart drawer + Phase 2 base CORE (BUILD-PLAN §1.4). Deferred by
 * paex-size-guide.liquid; injected once by paex-quick-add.js. Design size-system.js display half (export 2026-10-02)
 * verbatim but for one intervals() line; strings from the JSON island; textContent only; one IIFE. */
(function () {
  'use strict';
  if (customElements.get('paex-size-guide')) return;

  var KEY = 'paex:sg:unit';
  var MEM = {};
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var STR = {};
  function lang() { return String(document.documentElement.lang || 'en').toLowerCase().indexOf('fr') === 0 ? 'fr' : 'en'; }
  function readUnit() { try { var v = localStorage.getItem(KEY); if (v === 'imp' || v === 'met') return v; } catch (e) { /* storage-less */ } return MEM.unit || null; }
  function writeUnit(u) { MEM.unit = u; if (designMode) return; try { localStorage.setItem(KEY, u); } catch (e) { /* the mirror carries this load */ } }
  function t(l, k, v) {
    var s = STR[k] != null ? STR[k] : k;
    if (v) s = s.replace(/\{(\w+)\}/g, function (m, x) { return v[x] != null ? v[x] : m; });
    return s;
  }
  var ROLE = {};

  /* ---- size-system.js logic (display half; verbatim but for the one intervals() line) ---- */
  function num(v, l) { var s2 = String(v); return l === 'fr' ? s2.replace('.', ',') : s2; }
  function ftin(cm) { var tot = Math.round(cm / 2.54), ft = Math.floor(tot / 12); return ft + '′' + (tot - ft * 12) + '″'; }
  function defaultUnit(ch) { return ch && ch.unit === 'cm' ? 'met' : 'imp'; }
  var MEASURED = { height: 1, heightIn: 1, weight: 1, length: 1 };
  function hasUnits(ch) { return ch.cols.some(function (c) { return MEASURED[c.kind]; }); }
  function dnum(kind, v, u) {
    if (kind === 'height' || kind === 'heightIn') return u === 'met' ? Math.round(v) : Math.round(v / 2.54);
    if (kind === 'weight') return u === 'met' ? Math.round(v * 2) / 2 : Math.round(v * 2.20462);
    if (kind === 'length') return u === 'met' ? Math.round(v) : Math.round(v / 2.54 * 2) / 2;
    return v;
  }
  function dstep(kind, u) { return kind === 'weight' && u === 'met' ? 0.5 : 1; }
  function dstr(kind, n, u, l) {
    if (kind === 'height' && u !== 'met' && n >= 36) return Math.floor(n / 12) + '′' + (n % 12) + '″';
    return num(n, l);
  }
  function sfx(kind, n, u, l) {
    if (kind === 'height') return u === 'met' ? t(l, 'cm') : (n < 36 ? t(l, 'po') : '');
    if (kind === 'heightIn') return u === 'met' ? t(l, 'cm') : t(l, 'po');
    if (kind === 'weight') return u === 'met' ? t(l, 'kg') : t(l, 'lb');
    if (kind === 'length') return u === 'met' ? t(l, 'cm') : t(l, 'po');
    if (kind === 'age') return t(l, 'yrs');
    return '';
  }
  function withU(str, x2) { return x2 ? str + ' ' + x2 : str; }
  function fmtDisp(kind, n, u, l) { return withU(dstr(kind, n, u, l), sfx(kind, n, u, l)); }
  function dRange(kind, A, B, u, l, unitOn) {
    var sa = dstr(kind, A, u, l), sb = dstr(kind, B, u, l), s2 = sa === sb ? sa : sa + '–' + sb;
    return unitOn ? withU(s2, sfx(kind, B, u, l)) : s2;
  }
  function raw(kind, v, u, l) { return dstr(kind, dnum(kind, v, u), u, l); }
  function headUnit(kind, u, l) {
    if (kind === 'height') return u === 'met' ? t(l, 'cm') : t(l, 'ftin');
    if (kind === 'heightIn' || kind === 'weight' || kind === 'length') return sfx(kind, 99, u, l);
    return '';
  }
  function fmtVal(kind, v, u, l) { return fmtDisp(kind, dnum(kind, v, u), u, l); }
  function fmtRange(kind, a, b, u, l, unitOn) { return dRange(kind, dnum(kind, a, u), dnum(kind, b, u), u, l, unitOn); }
  function colOf(ch, key) { for (var i = 0; i < ch.cols.length; i++) if (ch.cols[i].key === key) return ch.cols[i]; return null; }
  function keyOf(ch, role) { for (var i = 0; i < ch.cols.length; i++) if (ch.cols[i].role === role) return ch.cols[i].key; return null; }
  function headLabel(c, u, l) { var hu = headUnit(c.kind, u, l); return c.label[l] + (hu ? ' (' + hu + ')' : ''); }

  function intervals(ch, key) {
    var list = ch.rows.map(function (rw, i) { return { i: i, c: rw.c[key] }; });
    var ups = list.filter(function (o) { return o.c && o.c.k === 'up'; }).sort(function (a, b) { return a.c.v - b.c.v; });
    // lower bound = the previous DISTINCT up value (equal "Up to" cells share a band)
    var prev = {}, lastDistinct = -Infinity, lastV = null;
    ups.forEach(function (o) { if (lastV !== null && o.c.v !== lastV) lastDistinct = lastV; lastV = o.c.v; prev[o.i] = lastDistinct; });
    return list.map(function (o) {
      var c = o.c; if (!c) return null;
      if (c.k === 'r') return [c.a, c.b];
      if (c.k === 's') return [c.v, c.v];
      if (c.k === 'up') return [prev[o.i], c.v];
      return null;
    });
  }
  function cellText(ch, ri, key, u, l, unitOn) {
    var c = ch.rows[ri].c[key], cl = colOf(ch, key);
    if (!c) return '—';
    if (c.k === 'x') return c.t[l];
    if (c.k === 's') return unitOn ? fmtVal(cl.kind, c.v, u, l) : raw(cl.kind, c.v, u, l);
    if (c.k === 'r') return fmtRange(cl.kind, c.a, c.b, u, l, unitOn);
    var iv = intervals(ch, key)[ri];
    if (!isFinite(iv[0])) return t(l, 'up_to', { v: unitOn ? fmtVal(cl.kind, c.v, u, l) : raw(cl.kind, c.v, u, l) });
    return fmtRange(cl.kind, iv[0], iv[1], u, l, unitOn);
  }

  /* ---- adapter: metaobject grid → module chart shape ---- */
  var ROLES = { height: 1, weight: 1, chest: 1, waist: 1, hips: 1, inseam: 1, age: 1 };
  function roleOf(key) { return ROLES[key] ? key : (/^shoe_/.test(key) ? 'shoe' : 'other'); }
  function L(s) { return { fr: s, en: s }; }
  function norm(s) {
    return String(s == null ? '' : s)
      .replace(/[“”″]|''/g, '"').replace(/[‘’′]/g, "'")
      .replace(/[–—]/g, '-').replace(/\s+/g, ' ').trim();
  }
  var UP_RE = /^(?:up to|jusqu'a|jusqu'à|max(?:imum)?\.?)\s*/i;
  var TOK_RE = /(\d+)\s*'\s*(\d+(?:[.,]\d+)?)?\s*"?|(\d+(?:[.,]\d+)?)(?:\s+(\d)\s*\/\s*(\d))?/g;
  // authored display body: unit tokens stripped (harness rule C4), range separators → en-dash, else as authored
  var UNIT_TAIL_RE = /\s*(?:"|in(?:ch(?:es)?)?|po|cm|mm|lbs?|kg)\.?$/i;
  var SEP_RE = /\s*(?:-|\sto\s|\sà\s)\s*/;
  function dispBody(body) {
    return body.split(SEP_RE).map(function (p) { return p.replace(UNIT_TAIL_RE, '').trim(); }).filter(Boolean).join('–');
  }
  // one authored cell → null | {k:'x',t} | {k:'s',v,d} | {k:'r',a,b,d} | {k:'up',v,d} (cm / kg; d = authored display body)
  function parseCell(rawText, col) {
    var s = norm(rawText);
    if (!s || s === '-' || s === '—') return null;
    var text = { k: 'x', t: L(s) };
    if (col.kind === 'cat' || col.kind === 'text' || col.kind === 'age') return text;
    var up = UP_RE.test(s), body = s.replace(UP_RE, ''), vals = [], m;
    TOK_RE.lastIndex = 0;
    while ((m = TOK_RE.exec(body)) && vals.length < 2) {
      var v;
      if (m[1] != null) v = { n: +m[1] * 12 + (m[2] ? parseFloat(m[2].replace(',', '.')) : 0), ftin: true };
      else v = { n: parseFloat(m[3].replace(',', '.')) + (m[4] ? +m[4] / +m[5] : 0) };
      if (!isNaN(v.n)) vals.push(v);
    }
    if (!vals.length) return text;
    var canon = vals.map(function (v) {
      var u = v.ftin ? 'in' : col.unit;
      if (u === 'in') return v.n * 2.54;
      if (u === 'lb') return v.n / 2.20462;
      return v.n;
    });
    var d = vals.some(function (v) { return v.ftin; }) ? null : dispBody(body);
    if (up) return { k: 'up', v: canon[0], d: d };
    if (canon.length === 1) return { k: 's', v: canon[0], d: d };
    return { k: 'r', a: Math.min(canon[0], canon[1]), b: Math.max(canon[0], canon[1]), d: d };
  }
  // which unit system a column was authored in (null = unitless)
  function colSys(c) { return c.unit === 'cm' || c.unit === 'kg' ? 'met' : (c.unit === 'in' || c.unit === 'lb' ? 'imp' : null); }
  // authored body at the authored unit (FR comma), except imperial height / "Up to" (module path); else cellText
  function displayCell(ch, ri, key, u, l) {
    var c = ch.rows[ri].c[key], cl = colOf(ch, key);
    if (c && c.d && c.k !== 'up' && cl && colSys(cl) === u && !(cl.kind === 'height' && u === 'imp')) {
      return l === 'fr' ? c.d.replace(/(\d)\.(\d)/g, '$1,$2') : c.d;
    }
    return cellText(ch, ri, key, u, l, false);
  }
  function adapt(data) {
    var ch = data.chart, seen = {};
    Object.keys(data.strings || {}).forEach(function (k) { STR[k] = data.strings[k]; });
    var cols = ch.cols.map(function (c, i) {
      var key = seen[c.key] ? c.key + '_' + i : c.key; seen[c.key] = 1;
      return { key: key, role: roleOf(c.key), kind: c.kind, unit: c.unit, label: L(c.label) };
    });
    cols.forEach(function (c) { if (c.role !== 'other' && !ROLE[c.role]) ROLE[c.role] = { fr: c.label.fr, en: c.label.en, lo: { fr: c.label.fr.toLowerCase(), en: c.label.en.toLowerCase() } }; });
    var rows = ch.rows.map(function (r) {
      var c = {};
      cols.forEach(function (col, i) { c[col.key] = parseCell(r.cells[i], col); });
      return { label: r.label, sub: r.sub ? L(r.sub) : null, opts: r.aliases || [r.label], c: c };
    });
    return { type: ch.type === 'one_size' ? 'garment' : ch.type, scope: ch.scope, group: ch.group, hand: !!ch.hand, finder: ch.finder_mode,
      unit: ch.unit_length === 'cm' || (ch.unit_length !== 'in' && ch.unit_weight === 'kg') ? 'cm' : 'in', aud: L(ch.audience), notes: [], cols: cols, rows: rows };
  }
  // preferred unit: shopper's stored choice > block setting > design rule
  function prefFor(data, ch) {
    var du = data.settings && data.settings.default_unit;
    if (du === 'imperial') return 'imp';
    if (du === 'metric') return 'met';
    return ch.type === 'body' ? 'imp' : defaultUnit(ch);
  }
  // DOM table from an island payload (textContent only); Phase 2.1 §2.3.8 opts.only / rowAttr / split (body table + costume details)
  var BODY_KEYS = { height: 1, weight: 1, chest: 1, waist: 1, hips: 1, age: 1 };
  function isStd(data) { var ch = data && data.chart || {}; return ch.source === 'standard_reference' && ch.type === 'body'; }
  function buildTable(data, opts) {
    opts = opts || {};
    var l = lang(), ch = adapt(data), u = opts.unit || readUnit() || prefFor(data, ch);
    if (opts.split) {
      var raw = (data.chart && data.chart.cols) || [], bodyIdx = [], otherIdx = [];
      raw.forEach(function (c, i) { (BODY_KEYS[c.key] ? bodyIdx : otherIdx).push(i); });
      if (!isStd(data) || !otherIdx.length || !bodyIdx.length) return buildTable(data, Object.assign({}, opts, { split: false }));
      var o = Object.assign({}, opts, { split: false, unit: u }), frag = document.createDocumentFragment();
      frag.append(buildTable(data, Object.assign({}, o, { only: bodyIdx, rowAttr: opts.rowAttr || 'row' })));
      var det = document.createElement('details'), sum = document.createElement('summary'), st = document.createElement('span'), sg = document.createElement('span'), db = document.createElement('div'), note = document.createElement('p'), wrap = document.createElement('div');
      det.className = 'paex-sg__howto paex-sg__costume'; sum.className = 'paex-sg__howto-summary'; st.textContent = t(l, 'costume_title'); sg.className = 'paex-sg__howto-sign'; sg.setAttribute('aria-hidden', 'true');
      db.className = 'paex-sg__howto-body paex-sg__costume-body'; note.className = 'paex-sg__costume-note'; note.textContent = t(l, 'costume_note'); wrap.className = 'paex-sg__tablewrap';
      wrap.append(buildTable(data, Object.assign({}, o, { only: otherIdx, rowAttr: 'ri', caption: t(l, 'costume_title') })));
      sum.append(st, sg); db.append(note, wrap); det.append(sum, db); frag.append(det);
      return frag;
    }
    var cols = ch.cols.map(function (c, i) { return { c: c, i: i }; }).filter(function (x) { return !opts.only || opts.only.indexOf(x.i) >= 0; });
    var table = document.createElement('table');
    table.className = opts.className || 'paex-sg__table';
    // <caption> = the table's first child; Ascent's .visually-hidden
    var caption = document.createElement('caption');
    caption.className = 'visually-hidden';
    caption.textContent = opts.caption || STR.link || t(l, 'size');
    var thead = document.createElement('thead'), hr = document.createElement('tr');
    var th0 = document.createElement('th'); th0.setAttribute('scope', 'col'); th0.textContent = t(l, 'size'); hr.append(th0);
    cols.forEach(function (x) { var th = document.createElement('th'); th.setAttribute('scope', 'col'); th.textContent = headLabel(x.c, u, l); if (opts.only) th.setAttribute('data-col', String(x.i)); hr.append(th); });
    thead.append(hr);
    var tbody = document.createElement('tbody');
    ch.rows.forEach(function (r, i) {
      var tr = document.createElement('tr'), th = document.createElement('th');
      if (opts.rowAttr) tr.setAttribute('data-' + opts.rowAttr, String(i));
      th.setAttribute('scope', 'row'); th.textContent = r.sub ? r.label + ' (' + r.sub[l] + ')' : r.label; tr.append(th);
      cols.forEach(function (x) { var td = document.createElement('td'); td.textContent = displayCell(ch, i, x.c.key, u, l); if (opts.only) td.setAttribute('data-col', String(x.i)); tr.append(td); });
      tbody.append(tr);
    });
    table.append(caption, thead, tbody);
    return table;
  }

  /* ---------------- Phase 1 element ---------------- */
  // analytics gate (TRACKING §d.1): data-analytics on the element (never a clone) or true
  function track(root, name, payload) {
    var el = root && typeof root === 'object' ? root : null;
    if (el ? (!el.hasAttribute('data-analytics') || el.dataset.originalSection != null) : root !== true) return;
    if (designMode) return;
    var p = Object.assign({ level: readLevel(), theme_id: THEME_ID, src: (el && el.dataset.src) || 'pdp', lang: lang() }, payload);
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('paex_size_guide:' + name, p); } catch (e) { /* additive */ }
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'paex_size_guide_' + name }, p)); } catch (e) { /* additive */ }
  }

  /* ---- Phase 2 CORE (BUILD-PLAN §1.4; WP1, frozen after stage 1) ---- */
  var SK = { v: 'paex:sg:v', profiles: 'paex:sg:profiles', active: 'paex:sg:active_by_group', level: 'paex:sg:level', nudge: 'paex:sg:nudge_dismissed_at', slot: 'paex:sg:slot:' };
  var LEVELS = { none: 0, chart: 1, finder: 2, profile: 3 }, GROUPS = ['infant', 'kid', 'teen', 'adult'];
  var SLOT_OK = { link: 1, nudge: 1, profile: 1, 'profile-2': 1, 'profile-stale': 1, 'profile-ask': 1, 'profile-box': 1, 'profile-card': 1, chips: 1, badge: 1 };
  var INPUTS_ON_ORDER = false;   // _paex_sg_inputs reserved, OFF (§1.8)
  var THEME_ID = (window.Shopify && Shopify.theme && Shopify.theme.id) || 0;
  var instances = new Map(), MAIN = null, READY = { finder: [], drawer: [], rec: [] }, LOAD = {}, noop = () => {};
  var esc = (s) => { s = String(s == null ? '' : s); return window.CSS && typeof CSS.escape === 'function' ? CSS.escape(s) : s.replace(/["\\]/g, '\\$&'); };
  var nz = (s) => String(s == null ? '' : s).trim().toLowerCase();
  // store (TRACKING §a.3): MEM mirror, no storage I/O in the editor
  function readPlain(k) { if (!designMode) { try { var v = localStorage.getItem(k); if (v != null) return v; } catch (e) { /* storage-less */ } } return MEM[k] == null ? null : MEM[k]; }
  function writePlain(k, s) { MEM[k] = s; if (designMode) return; try { localStorage.setItem(k, s); } catch (e) { /* the mirror carries this load */ } }
  function schemaOk() { if (MEM.__schema == null) { var v = readPlain(SK.v); MEM.__schema = v == null || v === '1'; } return MEM.__schema; }
  function sRead(k) { if (!schemaOk()) return null; var r = readPlain(k); if (r == null || typeof r !== 'string') return r; try { return JSON.parse(r); } catch (e) { return null; } }
  function sWrite(k, o) { if (!schemaOk()) return; MEM[k] = o; if (designMode) return; try { if (readPlain(SK.v) == null) writePlain(SK.v, '1'); localStorage.setItem(k, JSON.stringify(o)); } catch (e) { /* mirror */ } }
  function sRemove(k) { delete MEM[k]; if (designMode) return; try { localStorage.removeItem(k); } catch (e) { /* no-op */ } }
  function profiles() { var p = sRead(SK.profiles); return Array.isArray(p) ? p : []; }
  function clearSlotClasses() {                 // G11: every paex:sg:slot:* key
    var seen = Object.keys(MEM).filter((k) => k.indexOf(SK.slot) === 0);
    seen.forEach((k) => { delete MEM[k]; });
    if (designMode) return;
    try { Object.keys(localStorage).concat(seen).forEach((k) => { if (k.indexOf(SK.slot) === 0) localStorage.removeItem(k); }); } catch (e) { /* no-op */ }
  }
  function writeProfiles(list) { sWrite(SK.profiles, Array.isArray(list) ? list.slice(0, 10) : []); clearSlotClasses(); }
  function active() { var a = sRead(SK.active), o = {}; GROUPS.forEach((g) => { o[g] = a && a[g] != null ? a[g] : null; }); return o; }
  function setActive(g, id) {
    var a = active(), ids = profiles().map((p) => p.id);
    a[g] = id; GROUPS.forEach((k) => { if (a[k] != null && ids.indexOf(a[k]) < 0) a[k] = null; });
    sWrite(SK.active, a); clearSlotClasses();
  }
  function readLevel() { var r = sRead(SK.level); return r && LEVELS[r.l] ? r.l : 'none'; }
  function bumpLevel(next, gate) {
    var cur = readLevel(); if (!LEVELS[next] || LEVELS[next] <= LEVELS[cur]) return cur;
    sWrite(SK.level, { v: 1, l: next, t: THEME_ID, at: new Date().toISOString() });
    track(gate || (MAIN && MAIN.el) || false, 'level', { from: cur, to: next });
    if (MEM.attrWritten) levelAttribute();
    return next;
  }
  function readNudge() { var n = +readPlain(SK.nudge); return n > 0 ? n : null; }
  function dismissNudge() { writePlain(SK.nudge, String(Date.now())); }
  function slotKey(h) {   // per chart × locale × breakpoint (the hook reads the same key)
    var b = 'm'; try { if (window.matchMedia && matchMedia('(min-width:750px)').matches) b = 'd'; } catch (e) { /* no media */ }
    return SK.slot + h + ':' + lang() + ':' + b;
  }
  function slotClass(h) { var v = readPlain(slotKey(h)); return v ? String(v).split('+') : null; }
  function setSlotClass(h, cls, px) {   // px (> 0) → 'h<px>px' token (the hook's --paex-sg-m)
    var v = (cls || []).filter((c) => SLOT_OK[c]); if (px > 0 && isFinite(px)) v.push('h' + (Math.round(px * 100) / 100).toFixed(2) + 'px'); v = v.join('+');
    if (v) writePlain(slotKey(h), v); else sRemove(slotKey(h));
  }
  function demo(data) {                         // designMode only, MEM (D34)
    if (!designMode || !data || !data.demo) return;
    var now = new Date().toISOString(), p = Object.assign({ bands: {} }, data.demo, { updated_at: now, last_used_at: now });
    MEM[SK.profiles] = [p]; MEM[SK.active] = { infant: p.id, kid: p.id, teen: p.id, adult: p.id }; MEM[SK.level] = { v: 1, l: 'profile', t: THEME_ID, at: now };
    clearSlotClasses();
  }
  // outcome parts + analytics code (§1.8), the readable stamp, order attribute (TRACKING §c, §j)
  var tok = (s) => s == null ? '' : String(s).replace(/\|/g, '/').replace(/\s+/g, ' ').trim().slice(0, 24);
  function outcomeParts(o) {
    var r = o.result || null, tier = (r && r.tier) || '', named = r && (tier === 'green' || tier === 'amber') && r.size != null ? tok(r.size) : '', added = tok(o.added);
    var kind = named && added === named ? 'rec' : (named && o.resolution && o.resolution.profile ? 'ovr' : (o.chartOpened ? 'chart' : 'none'));
    return { kind: kind, added: added, tier: tier, kinds: (r && r.kinds) || '', chart: String(o.chart || (r && r.handle) || (o.data && o.data.chart && o.data.chart.handle) || '').slice(0, 48), rec: named, src: o.src === 'qa' ? 'qa' : 'pdp', sel: o.sel === 'pre' || o.sel === 'tap' ? o.sel : '',
      why: tier !== 'neutral' ? '' : r.kind === 'need' ? 'need' : r.kind === 'none' ? 'off' : r.idx != null && r.size == null ? 'unoffered' : 'nomatch', recLabel: tok(r && r.recLabel) };
  }
  function code(p) { return p && p.added && p.chart ? [p.kind + ':' + p.added, p.tier, p.kinds, p.chart, p.rec, p.src, p.sel].join('|') : null; }
  function picked(host) {                       // one value per option, .product-form-input order (NATIVE P5-P7)
    return host ? Array.prototype.map.call(host.querySelectorAll('.product-form-input'), (el) => {
      var r = el.querySelector('input[type="radio"]:checked'); if (r) return r.value;
      var s = el.querySelector('select'); return s ? s.value : null; }) : [];
  }
  function selectedSize(inst) {
    var d = inst.data.product, v = picked(inst.host)[d.option_index];
    if (v == null && !inst.host) {   // no picker (one-size, ruling 6): the form's variant names the token
      var f = document.getElementById(inst.data.form_id || 'product-form-' + inst.sectionId), vi = f && f.querySelector('[name="id"]');
      var row = vi ? (d.variants || []).filter((r) => String(r[0]) === String(vi.value))[0] : null;
      v = row && row[1] ? row[1][d.option_index || 0] : null;
    }
    return v == null ? null : v;
  }
  // the stamp = paex-size-advice.js sentence (TRACKING §j)
  function advice(p) { var A = window.paexSizeAdvice; return A && p && p.chart ? A.sentence(p) : null; }
  function setStamp(c, S, txt) {
    var inst = S ? instances.get(S) : MAIN; if (!inst || inst.clone) return;
    inst.outcome = c || null; if (txt) inst.advice = txt;
    var el = inst.el.querySelector('[data-paex-sg-prop]'); if (el) { if (txt) el.value = txt; el.disabled = !txt; }
  }
  function restamp(inst) {
    if (!inst || inst.clone) return;
    var size = selectedSize(inst), prev = inst.outcome, f = document.getElementById(inst.data.form_id || 'product-form-' + inst.sectionId), vi = f && f.querySelector('[name="id"]');
    var p = outcomeParts({ result: inst.result, resolution: inst.resolution, added: size, chartOpened: inst.chartOpened, src: 'pdp', chart: inst.data.chart.handle,
      sel: inst.preselected && !inst.touched ? 'pre' : (inst.touched ? 'tap' : '') }), c = code(p), txt = advice(p);
    if (c === prev && txt === inst.advice) return;
    setStamp(c, inst.sectionId, txt);
    if (prev != null && c !== prev) track(inst.el, 'outcome', { product_id: inst.data.product.id, variant_id: vi && vi.value ? +vi.value : (inst.data.product.selected_variant_id || null), size: size || '', outcome: c || '' });
  }
  function levelAttribute() {
    if (designMode) return;
    var A = window.paexSizeAdvice, level = readLevel(), txt = A && A.level(level); if (!txt || MEM.attrWritten === level) return;
    MEM.attrWritten = level;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', b = window.PaexCartBridge;
    var perform = () => fetch(root + 'cart/update.js', { method: 'POST', cache: 'no-store', credentials: 'same-origin', keepalive: true, headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [A.ATTR]: txt } }) }).then((r) => r.json().catch(() => null)).catch(() => { MEM.attrWritten = null; });
    return b && typeof b.enqueue === 'function' ? b.enqueue(perform) : perform();
  }
  // loaders + ready callbacks
  var loaded = (kind) => kind === 'rec' ? !!customElements.get('paex-size-rec') : !!window.paexSizeGuide[kind];
  function fire(kind) { var q = READY[kind]; READY[kind] = []; q.forEach((cb) => { try { cb(window.paexSizeGuide); } catch (e) { /* a listener error never breaks the loader */ } }); }
  function ensure(kind) {
    if (loaded(kind)) { fire(kind); return Promise.resolve(window.paexSizeGuide); }
    if (LOAD[kind]) return LOAD[kind];
    var a = document.querySelector(kind === 'rec' ? 'paex-size-rec[data-rec-src]' : 'paex-size-guide[data-' + kind + '-src]'), q = document.getElementById('Paex-Quick-Add');
    var src = (a && a.getAttribute('data-' + kind + '-src')) || (q && q.getAttribute('data-paex-sg-' + kind + '-src'));
    if (!src) return Promise.reject(new Error('paex-sg: no ' + kind + ' src'));
    LOAD[kind] = new Promise((res, rej) => {
      var s = document.createElement('script'); s.src = src;
      s.onload = () => { if (loaded(kind)) { fire(kind); res(window.paexSizeGuide); } else { LOAD[kind] = null; rej(new Error('paex-sg: ' + kind + ' asset empty')); } };
      s.onerror = () => { LOAD[kind] = null; rej(new Error('paex-sg: ' + kind + ' asset failed')); };
      document.head.append(s);
    });
    return LOAD[kind];
  }
  function onReady(kind, cb) {
    if (typeof cb !== 'function') return;
    if (loaded(kind)) { cb(window.paexSizeGuide); return; }
    READY[kind].push(cb);
    if (kind === 'rec' && !LOAD.recWait && typeof customElements.whenDefined === 'function') { LOAD.recWait = true; customElements.whenDefined('paex-size-rec').then(() => { fire('rec'); }); }
  }
  // sizes (X26): DOM availability wins, island `a` only without a node
  function sizes(inst) {
    var d = inst.data.product, k = d.option_index, host = inst.host || null, others = picked(host);
    return (d.options || []).map((v) => {
      var c = (d.variants || []).filter((row) => { var o = row[1]; if (o[k] !== v) return false;
        for (var j = 0; j < o.length; j++) { if (j !== k && others[j] != null && o[j] !== others[j]) return false; } return true; })[0] || null;
      var a = null, input = host && host.querySelector('input[type="radio"][name="' + esc(d.option_name) + '"][value="' + esc(v) + '"]');
      var opt = !input && host && host.querySelector('select option[value="' + esc(v) + '"]');
      if (input) a = !input.classList.contains('disabled');
      else if (opt) a = !opt.hasAttribute('data-disabled');
      else if (c) a = c[2] === 1;
      return { v: v, id: c ? c[0] : null, a: a, skuBlank: c ? c[3] === 1 : null };
    });
  }
  var hd = (s) => nz(s).replace(/\s*\([^()]*\)$/, '');   // R4 head token
  var sk = (s) => nz(s).replace(/[–—]/g, '-').replace(/ - /g, '-').replace(/months?|mois/g, 'm').replace(/ m/g, 'm').replace(/(\d)m/g, '$1');   // R4b sub-label key ('6-12M' = '6-12' = '6-12 mois'; the Liquid sites mirror it)
  function rowFor(inst, opt) {   // full alias, else head token (R4), else SUB-LABEL (R4b) — naming ONE row, else -1
    var o = nz(opt), rows = inst.chart.rows, i, h = hd(o), k = sk(o), hit = -1, f = h !== o ? (r) => r.opts.some((a) => nz(a) === h) : (r) => !!r.sub && sk(r.sub.fr) === k;
    for (i = 0; i < rows.length; i++) if (rows[i].opts.some((a) => nz(a) === o)) return i;
    if (!h) return -1;
    for (i = 0; i < rows.length; i++) if (f(rows[i])) { if (hit >= 0) return -1; hit = i; }
    return hit;
  }
  function optionFor(inst, i) {
    var r = inst.chart.rows[i], opts = inst.data.product.options || [], out = null;
    if (r) r.opts.some((a) => opts.some((v) => { if (nz(v) === nz(a)) out = v; return out != null; }));
    if (r && out == null) opts.some((v) => { if (rowFor(inst, v) === i) out = v; return out != null; });   // R4 / R4b
    return out;
  }
  // applySize (NATIVE §3.1 / §3.4 / §3.6): true only when the host sequence ran
  function applySize(S, opt, o) {
    o = o || {};
    return new Promise((res) => {
      var inst = instances.get(S), host = inst && inst.host, d = inst && inst.data.product, target = null;
      if (!inst || inst.clone || !host || host.dataset.originalSection) return res(false);
      if (typeof host.updateOptions !== 'function' || typeof host.renderProductInfo !== 'function' || typeof host.toggleAddButtonStatus !== 'function') return res(false);
      var input = host.querySelector('input[type="radio"][name="' + esc(d.option_name) + '"][value="' + esc(opt) + '"]');
      if (input) {
        if (input.checked || input.classList.contains('disabled')) return res(false);
        input.checked = true; target = input;
      } else {
        var slot = host.querySelector('[data-paex-sg-slot]') || document.querySelector('[data-paex-sg-slot][data-section="' + esc(S) + '"]');
        var sel = document.getElementById((slot && slot.dataset.paexSgSelect) || 'Option-' + S + '-' + d.option_index), ok = false;
        if (!sel || sel.tagName !== 'SELECT' || sel.value === opt) return res(false);
        Array.prototype.forEach.call(sel.options, (x) => { if (x.value === opt && !x.hasAttribute('data-disabled')) ok = true; });
        if (!ok) return res(false);
        sel.value = opt; target = sel;
      }
      if (o.from === 'pre') inst.preselecting = true; else inst.focusOpt = o.silent ? null : opt;
      inst.applied = opt;
      host.toggleAddButtonStatus(true, '');
      if (typeof host.removeErrorMessage === 'function') host.removeErrorMessage();
      host.updateOptions(target);
      host.renderProductInfo({ id: 'paex-sg-nofocus' });
      if (o.from === 'pre') inst.preselected = true;
      track(inst.el, 'recommendation_applied', { handle: inst.data.chart.handle, size: opt, tier: inst.result ? inst.result.tier : '', how: o.from || 'row' });
      res(true);
    });
  }
  // paint-only guard 8 (G3 fail closed; R2: _a, any store in stock, live avail)
  function paintOnlyOk(S, targetId, currentId) {
    var el = document.querySelector('paex-delivery-method[data-section="' + esc(S) + '"]:not([data-original-section])');
    if (!el) return Promise.resolve(true);
    var timeout = new Promise((_, rej) => { setTimeout(() => { rej(new Error('paex-sg: delivery not defined')); }, 1500); });
    return Promise.race([customElements.whenDefined('paex-delivery-method'), timeout]).then(() => {
      if (!el.data || !el.data.variants) return false;
      var a = el.data.variants[String(targetId)], b = el.data.variants[String(currentId)], onl = String((el.data.settings && el.data.settings.onlineLocId) || '');
      var store = (r) => Object.keys(r).some((k) => k.charAt(0) !== '_' && k !== onl && Number(r[k]) > 0);
      if (!a || !b || a._a !== b._a || store(a) !== store(b)) return false;
      var la = el.liveAvail && (String(targetId) in el.liveAvail) ? el.liveAvail[String(targetId)] : a._a === 1;
      var lb = el.liveAvail && (String(currentId) in el.liveAvail) ? el.liveAvail[String(currentId)] : b._a === 1;
      return la === lb;
    }, () => false);
  }
  // markers (DRAWER §12, chart-only safe)
  function paintMarkers(inst) {
    var R = inst.result, recRow = R && R.tier !== 'neutral' && typeof R.row === 'number' ? R.row : -1, tt = (k) => STR[k] != null ? STR[k] : '';
    var sel = selectedSize(inst), selRow = sel != null ? rowFor(inst, sel) : -1, hasOpts = (inst.data.product.options || []).length > 0;
    inst.dialog.querySelectorAll('tr[data-row]').forEach((tr) => {
      var i = +tr.dataset.row, th = tr.querySelector('.paex-sg__rowhead'), mk = tr.querySelector('[data-paex-sg-mark]');
      if (!mk && th) { mk = document.createElement('span'); mk.className = 'paex-sg__mark'; mk.setAttribute('data-paex-sg-mark', ''); mk.hidden = true; th.append(mk); }
      var rec = i === recRow, isSel = i === selRow, na = hasOpts && optionFor(inst, i) == null;
      tr.classList.toggle('paex-is-rec', rec); tr.classList.toggle('paex-is-sel', isSel); tr.classList.toggle('paex-is-na', na);
      var txt = rec && isSel ? tt('rec_sel') : (rec ? tt('recommended') : (isSel ? tt('selected') : (na ? tt('not_offered') : '')));
      if (mk) { mk.textContent = txt; mk.hidden = !txt; }
    });
  }
  // setResult (S1): markers, stamp, paex:sg:result
  function setResult(result, m) {
    m = m || {};
    var inst = (m.sectionId && instances.get(m.sectionId)) || MAIN; if (!inst) return;
    inst.result = result || null;
    if (m.resolution !== undefined) inst.resolution = m.resolution;
    inst.activeProfileId = m.profileId == null ? null : m.profileId;
    paintMarkers(inst); restamp(inst);
    try { document.dispatchEvent(new CustomEvent('paex:sg:result', { detail: { sectionId: inst.sectionId, source: m.source || null, profileId: inst.activeProfileId, result: inst.result } })); } catch (e) { /* no CustomEvent */ }
  }
  // openers (DRAWER §3.4, NATIVE §8, G2), hash open, variantChange
  function instByDialog(id) { var out = null; instances.forEach((i) => { if (i.dialog && i.dialog.id === id) out = i; }); return out; }
  function openView(inst, mode, opts) {
    var D = window.paexSizeGuide.drawer; inst.dialog.dataset.paexSgMode = mode;   // finder-first
    if (D && typeof D.ensureFinder === 'function') { D.ensureFinder(inst.sectionId, mode, opts); return; }
    var box = inst.dialog.querySelector('[data-paex-sg-finder]'), ld = box && box.querySelector('[data-paex-sg-loading]');
    if (box) { box.hidden = false; box.setAttribute('aria-busy', 'true'); if (ld) ld.hidden = false; }
    inst.pendingView = { mode: mode, opts: opts };
    ensure('drawer').then(() => ensure('finder')).then(() => {
      var pv = inst.pendingView; inst.pendingView = null;
      if (pv) window.paexSizeGuide.drawer.ensureFinder(inst.sectionId, pv.mode, pv.opts);
    }).catch(() => { inst.pendingView = null; if (box) { box.hidden = true; box.removeAttribute('aria-busy'); if (ld) ld.hidden = true; } });
  }
  var SG_CTL = '[id^="PaexSgOpen-"], [data-paex-sg-open], [data-paex-sg-ask], .paex-sg__find, .paex-sg__chip, [data-paex-sg-slot]';   // C7: never a shopper touch
  function onOpener(e) {
    if ((e.type === 'pointerdown' || e.type === 'keydown') && !(e.target && e.target.closest && e.target.closest(SG_CTL))) instances.forEach((i) => { if (i.host && e.target && i.host.contains(e.target)) { i.touched = true; i.preselecting = false; } });
    var op = e.target && e.target.closest && e.target.closest('[data-paex-sg-open]'); if (!op) return;
    var inst = instByDialog(op.getAttribute('aria-controls')); if (!inst) return;
    if (e.type === 'keydown' && ((e.code !== 'Enter' && e.code !== 'Space') || op.tagName === 'BUTTON' || op.tagName === 'A')) return;
    if (e.type === 'pointerdown' || e.type === 'focus') { if (inst.finderOn) { ensure('finder').catch(noop); ensure('drawer').catch(noop); } return; }
    var u = readUnit(); if (u && u !== inst.el.unit) inst.el.setUnit(u, false);
    inst.returnTarget = op.dataset.paexSgReturn || null;
    if (inst.finderOn) openView(inst, op.dataset.paexSgMode || 'chart', { profileId: op.dataset.paexSgProfile || null, view: op.dataset.paexSgView || null, type: op.dataset.paexSgType || null, from: op.dataset.paexSgReturn || (op.id === 'PaexSgOpen-' + inst.sectionId ? 'link' : 'hash') });
    if (!op.modal && typeof inst.dialog.show === 'function') {   // D13-3: open attr now, trapFocus/scroll lock next frame
      e.preventDefault(); inst.dialog.setAttribute('open', '');
      if (typeof requestAnimationFrame === 'function') requestAnimationFrame(() => inst.dialog.show(op)); else inst.dialog.show(op);
    }
  }
  function hashOpen() {
    var inst = MAIN;
    try { if (!inst || location.hash !== '#paex-size-guide' || inst.dialog.hasAttribute('open')) return; } catch (e) { return; }
    inst.returnTarget = null;
    if (inst.finderOn) openView(inst, 'chart', { profileId: null, view: null, from: 'hash' });
    if (typeof inst.dialog.show === 'function') inst.dialog.show(document.getElementById('PaexSgOpen-' + inst.sectionId));
  }
  function onVariantChange(ev) {
    var d = ev && ev.data, inst = d && d.sectionId != null ? instances.get(String(d.sectionId)) : null; if (!inst) return;
    if (inst.preselecting) {
      inst.preselecting = false;
      if (selectedSize(inst) !== inst.applied) inst.touched = true;             // the shopper's tap won the race
      else if (!inst.data.settings || inst.data.settings.reset_user_chose !== false) Promise.resolve().then(() => {
        var f = document.getElementById(inst.data.form_id || 'product-form-' + inst.sectionId), pf = f && f.closest('product-form');
        if (pf && !pf.dataset.originalSection && 'userChoseVariant' in pf) pf.userChoseVariant = false;
      });
    } else inst.touched = true;
    var fo = inst.focusOpt; inst.focusOpt = null;
    if (fo != null && inst.host && !inst.dialog.hasAttribute('open')) {
      var r = inst.host.querySelector('input[type="radio"][name="' + esc(inst.data.product.option_name) + '"][value="' + esc(fo) + '"]');
      if (r && typeof r.focus === 'function') r.focus({ preventScroll: true });
    }
    paintMarkers(inst); restamp(inst);
  }
  function register(el) {
    var S = el.dataset.section, data = el.data;
    var inst = { sectionId: S, clone: el.dataset.originalSection != null, el: el, dialog: el.dialog, host: document.getElementById(data.host_id || 'Variant-Selects-' + S), data: data, chart: el.chart, fc: null,
      finderOn: !!(data.settings && data.settings.finder), resolution: null, result: null, activeProfileId: null, crossPick: null, applied: null, chartOpened: false, touched: false,
      preselecting: false, preselected: false, pendingView: null, outcome: null, advice: null, returnTarget: null };
    instances.set(S, inst); el.inst = inst;
    if (inst.clone) { var cs = el.querySelector('[data-paex-sg-prop]'); if (cs) cs.disabled = true; paintMarkers(inst); return; }   // clones never stamp
    if (!MAIN) MAIN = inst;
    THEME_ID = data.theme_id || THEME_ID;
    demo(data);
    if (profiles().length && LEVELS[readLevel()] < LEVELS.profile) bumpLevel('profile', el);
    paintMarkers(inst); restamp(inst); hashOpen();
  }
  function refocus(inst) {
    if (document.activeElement !== document.body) return;
    var q = inst.returnTarget ? '[data-paex-sg-return="' + esc(inst.returnTarget) + '"]' : null;
    var tg = (q && ((inst.host && inst.host.querySelector(q)) || document.querySelector(q))) || document.getElementById('PaexSgOpen-' + inst.sectionId);
    if (tg && typeof tg.focus === 'function') tg.focus({ preventScroll: true });
  }


  class PaexSizeGuide extends HTMLElement {
    connectedCallback() {
      if (this.booted) return;
      this.booted = true;
      try { this.boot(); } catch (e) { /* the SSR chart stays readable as authored */ }
    }
    boot() {
      var island = this.querySelector('script[data-paex-sg-data]');
      this.dialog = document.getElementById(this.dataset.dialog);
      if (!island || !this.dialog) return;
      this.data = JSON.parse(island.textContent);
      this.chart = adapt(this.data);
      this.lang = lang();
      this.unit = readUnit() || this.dialog.dataset.prefUnit || prefFor(this.data, this.chart);
      var self = this;
      this.applyUnit(this.unit);
      this.dialog.querySelectorAll('[data-paex-sg-units] .paex-sg__unit').forEach(function (btn) {
        btn.addEventListener('click', function () { self.setUnit(btn.dataset.unit, true, btn); });
      });
      // CORE: a failure never takes the Phase 1 drawer down
      try { register(this); } catch (e) { /* chart-only */ }
      var wrap = this.dialog.querySelector('[data-paex-sg-scroll]'), chart = this.dialog.querySelector('[data-paex-sg-chart]');
      if (wrap && chart) {
        wrap.addEventListener('scroll', function () {
          if (wrap.scrollLeft > 0) chart.classList.add('paex-is-scrolled');
          wrap.classList.toggle('paex-is-scrolled-y', wrap.scrollTop > 0);
        }, { passive: true });
      }
      // the engine toggles `open`; closed = display:none (no aria-hidden)
      this.openObserver = new MutationObserver(function () {
        if (self.dialog.hasAttribute('open')) {
          self.fit();
          track(self, 'open', { chart_type: self.data.chart.type, audience: self.data.chart.audience, handle: self.data.chart.handle });
          bumpLevel('chart', self);
          if (self.inst) { self.inst.chartOpened = true; restamp(self.inst); }
        } else if (self.inst) refocus(self.inst);
      });
      this.openObserver.observe(this.dialog, { attributes: true, attributeFilter: ['open'] });
      // ESC backstop: the engine hears keyup inside the dialog only
      this.onKeyup = function (e) {
        if (!e.code || e.code.toUpperCase() !== 'ESCAPE') return;
        if (self.dialog.hasAttribute('open') && typeof self.dialog.hide === 'function') self.dialog.hide();
      };
      document.addEventListener('keyup', this.onKeyup);
    }
    // editor re-render hygiene
    disconnectedCallback() {
      if (this.onKeyup) { document.removeEventListener('keyup', this.onKeyup); this.onKeyup = null; }
      if (this.openObserver) { this.openObserver.disconnect(); this.openObserver = null; }
    }
    // overflow hint + tab stop when it scrolls (re-run on a unit switch)
    fit() {
      var wrap = this.dialog.querySelector('[data-paex-sg-scroll]'), chart = this.dialog.querySelector('[data-paex-sg-chart]');
      if (chart && wrap) chart.classList.toggle('paex-no-overflow', wrap.scrollWidth <= wrap.clientWidth + 1);
      if (wrap) wrap.tabIndex = (wrap.scrollWidth > wrap.clientWidth + 1 || wrap.scrollHeight > wrap.clientHeight + 1) ? 0 : -1;
    }
    applyUnit(u) {
      var ch = this.chart, l = this.lang, dlg = this.dialog;
      if (!hasUnits(ch)) return;
      var heads = dlg.querySelectorAll('[data-paex-sg-unit]');
      ch.cols.forEach(function (c, i) { var hu = headUnit(c.kind, u, l); if (heads[i]) heads[i].textContent = hu ? ' (' + hu + ')' : ''; });
      dlg.querySelectorAll('[data-paex-sg-cell]').forEach(function (cell) {
        var tr = cell.closest('tr'), ri = tr && tr.dataset.row != null ? +tr.dataset.row : (tr && tr.dataset.ri != null ? +tr.dataset.ri : 0), ci = +cell.dataset.col;   // Phase 2.1: costume rows carry data-ri
        if (!ch.cols[ci] || !ch.rows[ri]) return;
        cell.textContent = displayCell(ch, ri, ch.cols[ci].key, u, l);
      });
      dlg.querySelectorAll('[data-paex-sg-units] .paex-sg__unit').forEach(function (btn) { btn.setAttribute('aria-pressed', String(btn.dataset.unit === u)); });
    }
    setUnit(u, persist, focusEl) {
      if (u !== 'imp' && u !== 'met') return;
      this.unit = u;
      this.applyUnit(u);
      if (this.dialog.hasAttribute('open')) this.fit();
      if (persist) writeUnit(u);
      // re-arm the engine's trap after a re-render
      if (this.dialog.hasAttribute('open') && typeof webvista !== 'undefined' && typeof webvista.trapFocus === 'function') {
        webvista.trapFocus(this.dialog, focusEl || document.activeElement);
      }
      if (persist) track(this, 'unit', { unit: u });
    }
  }
  window.paexSizeGuide = {
    // display half (the finder asset extends logic; ROLE by reference)
    logic: { t, num, ftin, defaultUnit, hasUnits, dnum, dstep, dstr, sfx, fmtDisp, dRange, raw, headUnit, fmtVal, fmtRange, colOf, keyOf, headLabel, intervals, cellText, displayCell, ROLE },
    adapter: { adapt, parseCell, prefFor, readUnit, lang },
    render: { table: buildTable },
    // CORE (§1.4)
    store: { readPlain, writePlain, read: sRead, write: sWrite, remove: sRemove, profiles, writeProfiles, active, setActive, readLevel, bumpLevel, readNudge, dismissNudge, slotClass, setSlotClass, clearSlotClasses, designMode, demo },
    track: { event: track, outcomeParts, code, advice, levelAttribute, setStamp, outcome: (S) => { var i = S ? instances.get(S) : MAIN; return i ? i.outcome : null; } },
    ensure: { finder: () => ensure('finder'), drawer: () => ensure('drawer'), rec: () => ensure('rec') },
    sizes, rowFor, optionFor, applySize, paintOnlyOk, setResult,
    instances, get state() { return MAIN; }, instance: (S) => instances.get(S) || null,
    ready: { onFinder: (cb) => onReady('finder', cb), onDrawer: (cb) => onReady('drawer', cb), onRec: (cb) => onReady('rec', cb) },
    get THEME_ID() { return THEME_ID; }, lang: lang
  };
  // module-level installs, exactly once (§1.4 G8)
  ['pointerdown', 'focus', 'click', 'keydown'].forEach((ty) => { document.addEventListener(ty, onOpener, true); });
  document.addEventListener('submit', (e) => { var id = (e.target && e.target.getAttribute('id')) || ''; if (id.indexOf('product-form-') === 0) restamp(instances.get(id.slice(13))); }, true);
  if (typeof webvista !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined' && webvista && typeof webvista.subscribe === 'function') {
    webvista.subscribe(PUB_SUB_EVENTS.cartUpdate, () => { levelAttribute(); });
    webvista.subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }
  if (typeof window.addEventListener === 'function') window.addEventListener('hashchange', hashOpen);

  customElements.define('paex-size-guide', PaexSizeGuide);
})();
